import React from 'react';
import intl from 'react-intl-universal';
import { Column, RowInfo } from 'react-table';
import {
  getVideoTypeDisplayText,
  isControllerConnected,
  getUsageDisplayText,
  getControllerTypeCondensedText
} from 'utils/roomSystemUtils';
import ControllerCell from './CustomCells/ControllerCell';
import DisplayNameCell from './CustomCells/DisplayNameCell';
import { UNKNOWN } from '../../constants/roomSystemConstants';
import { OnlineStatus } from './OnlineStatus/OnlineStatus';
import { RoomSystem } from 'typings/types';

/**
 * If pairingStatus is DELETED (unpaired) or null, then display nothing for Controller.
 * If tablet, and no linked devices, also return null
 */
export const getControllerCell = (row: RowInfo) => {
  const {phoneModelNumber, linkedDevices} = row.original;
  if (!isControllerConnected(phoneModelNumber, linkedDevices)) {
    return null;
  }
  return (
    <div>
      <ControllerCell
        row={row}
      />
    </div>
  );
};

export const transformRoomSystemData = (listData: RoomSystem[]): RoomSystem[] => {
  listData.forEach((dataRow: RoomSystem) => {
    dataRow.usageText = getUsageDisplayText(dataRow);
    dataRow.controllerText = getControllerTypeCondensedText(dataRow);
    dataRow.videoType = getVideoTypeDisplayText(dataRow.platform);
  });
  return listData;
};

export const roomSystemColumnConfig = (): Column[] => {
  return ([
    {
      Header: intl.get('name'),
      accessor: 'systemName',
      Cell: (row: RowInfo) => {
        return (
          <DisplayNameCell
            row={row}
          />
        );
      },
    }, {
      Header: intl.get('status'),
      accessor: 'availability.status',
      Cell: (row: RowInfo) => {
        const { systemName, availability } = row.original;
        if (!systemName) {
          return null;
        }

        return (
          <OnlineStatus regStatus={(availability) ? availability.status : UNKNOWN} />
        );
      },
    }, {
      Header: intl.get('extension'),
      accessor: 'extension',
    }, {
      Header: intl.get('usage'),
      accessor: 'usageText',
    }, {
      Header: intl.get('videoType'),
      accessor: 'videoType',
    }, {
      Header: intl.get('controllerType'),
      accessor: 'controllerText',
      Cell: (row: RowInfo) => {
        return getControllerCell(row);
      },
    }
  ]);
};
